export enum ErrorCode {
  ZipCodeMissing = 4003,
  PhoneNumberMissingOrInvalid = 4004,
  CardExpired = 3013,
  InvalidExpirationDate = 3014,
  InvalidCardNumber = 3015,
  CardTypeIsNotSupported = 3017,
  TestCardDecline = 3020,
  InvalidCVV = 3016,
}
